import React from 'react';
import { HeadingWithBody, TileSelect } from '@99designs/spa-common';
import { STEP_LOGO } from '../constants';
import type { StepComponentProps } from '../../components/Onboarder/Config';
import type { SelectedValues } from '../config';

export type LogoValue = 'logo-required' | 'logo-not-required';

export function LogoStepInputs({ data, onChange }: StepComponentProps<SelectedValues>) {
    return (
        <TileSelect<LogoValue>
            name={STEP_LOGO}
            value={data.logo}
            options={[
                {
                    label: <HeadingWithBody heading={__('Yes')} />,
                    value: 'logo-required',
                },
                {
                    label: <HeadingWithBody heading={__('No')} />,
                    value: 'logo-not-required',
                },
            ]}
            onChange={(value, name) => {
                const newData: SelectedValues = {
                    ...data,
                    [name]: value,
                };
                onChange(newData);
            }}
        />
    );
}
